import { useState, useEffect } from 'react';
import api from '../services/API';

export function useSiteBloqueado() {
  const [isBloqueado, setIsBloqueado] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verificarBloqueio = async () => {
      try {
        const response = await api.get('/api/configuracoes/site-bloqueado');
        
        if (response.data && response.data.bloquearSite) {
          setIsBloqueado(true);
        } else {
          setIsBloqueado(false);
        }
      } catch (error) {
        // Se não conseguir verificar, assume que não está bloqueado
        setIsBloqueado(false);
      } finally {
        setLoading(false);
      }
    };

    verificarBloqueio();
  }, []);

  return { isBloqueado, loading };
}
